import React, { useState } from 'react';
import useRUMView from 'common-datadog/useRUMView';
import PhoneUpdate from '../PhoneUpdate';
import PhoneVerify from '../PhoneVerify';

const Phone = () => {
  useRUMView('phone');
  const [showUpdate, setShowUpdate] = useState(false);

  if (showUpdate) {
    return <PhoneUpdate onDone={() => setShowUpdate(false)} />;
  }

  return <PhoneVerify onUpdate={() => setShowUpdate(true)} />;
};

export default Phone;
